// extracted by mini-css-extract-plugin
export default {"node":"CirclePack_node__sq5xT","own-resources":"CirclePack_own-resources__3oghL","root-node":"CirclePack_root-node__oOSJq","fake-node":"CirclePack_fake-node__4Im94"};